import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';

const { FiRefreshCw, FiHome, FiAlertCircle } = FiIcons;

const ServerError = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <Icon icon={FiAlertCircle} color="danger" size="3xl" className="mx-auto mb-4" />
          <h1 className="text-foreground text-6xl font-bold mb-4">500</h1>
          <h2 className="text-foreground text-2xl font-semibold mb-4">Server Error</h2>
          <p className="text-muted-foreground mb-8">
            Something went wrong on our end. Our team has been notified and is working to fix this issue.
          </p>
        </div>

        <div className="flex justify-center space-x-4">
          <Button onClick={handleRefresh} className="gap-2">
            <Icon icon={FiRefreshCw} color="white" />
            <span>Try Again</span>
          </Button>

          <Button variant="outline" asChild>
            <Link to="/" className="inline-flex items-center gap-2">
              <Icon icon={FiHome} size="sm" />
              <span>Go to Dashboard</span>
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;